import {DataTypeProvider} from "@devexpress/dx-react-grid";
import React, { useEffect, useRef, useState } from "react";

import classes from "../AnnualRemuneration.module.css";
//import { attentionIcon, circleIcon, tickCircleGreenIcon, tickCircleIcon, grid_cell_editable } from "../AnnualRemuneration.module.css";

function useOnClickOutside(ref, handler) {
    useEffect(
      () => {
          const listener = (event) => {
              if (!ref.current || ref.current.contains(event.target)) {
                  return;
              }
              handler(event);
          };
          document.addEventListener("mousedown", listener);
          document.addEventListener("touchstart", listener);
          return () => {
              document.removeEventListener("mousedown", listener);
              document.removeEventListener("touchstart", listener);
          };
      },
      [ref, handler]
    );
}

const decimalFormater = (value, fieldFormat) => {
    if (typeof (value) === 'number'){
        const fractionDigitsStr = fieldFormat.replace('N.', '');
        let fractionDigits = parseInt(fractionDigitsStr);
        if (isNaN(fractionDigits)) {
            fractionDigits = 0;
        }
        const integralPart = Math.floor(value);
        const decimalPart = value - integralPart;
        const result = integralPart.toString().split('').reverse().reduce((memoValue, value, index) => {
            return ((index+1)%3===0 ? ' ': '') + value + memoValue;
        })
        return result + (fractionDigits == 0 ? '' : ('.' + decimalPart.toFixed(fractionDigits).replace('0.', '')));
    }
    return value;
}

const IsFix = ({ value }) => {
    const className = value === 0 && classes.circleIcon ||
      value === 1 && classes.tickCircleIcon ||
      value === 2 && classes.tickCircleGreenIcon;
    return <div className={className} />;
}

const Web_MultiLabel = ({column, row, highlightRows, value}) => {
    let result = [];
    const rowIndex = row.treeInfo.RowIndex || 0;
    const level = row.treeInfo.Level;
    const columnName = column.name;
    for(let i = 0; i < column.fieldInfo.length; i++ ) {
        const c = column.fieldInfo[i];
        const fName = c.name;
        const value = row[fName];
        const key = `${rowIndex}_${columnName}_${fName}`;

        if (fName === 'IsFix') {
            result = [<IsFix key={key} value={value} />, ...result];
        } else {
            result = [<Cell highlightRows={highlightRows} key={key} column={c} row={row} value={value} />, ...result];
        }
    }

    return result;
}

const CellFormatter = ({isEditable, value = '', highlight, tooltip, level, fieldType, fieldFormat, fieldName, rowIndex, applyChanges}) => {
    const ref = useRef(null);
    const [editMode, setEditMode] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);
    let stringValue = currentValue;

    const save = () => {
        if (editMode) {
            setEditMode(false);
            if (typeof (applyChanges) === "function") {
                applyChanges({ value: currentValue, fieldName, rowIndex });
            }
        }
    }

    useOnClickOutside(ref, save);

    const changeHandler = (e) => {
        setCurrentValue(e.target.value);
    }

    const keyHandler = (e) => {
        switch (e.key) {
            case "Down":
            case "ArrowDown":
            case "Up":
            case "ArrowUp":
            case "Enter":
                save();
                break;
        }
    }

    const clickHandler = (e) => {
        if (isEditable) {
            e.stopPropagation();
            setEditMode(true);
        }
    }

    if(['decimal', 'int'].indexOf(fieldType) >= 0){
        const val = parseFloat(currentValue);
        if (!isNaN(val)) {
            stringValue = decimalFormater(val, fieldFormat);
        }
    }

    let style = (level === 3 && fieldName === "OrgStructShortName") ? {marginLeft: "20px"} : {};
    style = (fieldName === "ValueChange_App" && isEditable) ? {...style, backgroundColor: "#eacb96", minHeight: "22px"} : style;

    tooltip = tooltip || value;

    if (!isEditable) {
        if (highlight) {
            style.backgroundColor="#eacb96";
        }
        return (
            <span className={`w-100 dx-g-bs4-table-tree-content pl-2 pr-2`} title={tooltip} onClick={clickHandler} ref={ref} style={style}>
                {(stringValue || <>&nbsp;</>)}
            </span>
        );
    }

    return (
      <div className={`w-100 dx-g-bs4-table-tree-content pl-2 pr-2 ${isEditable && classes.grid_cell_editable || ''}`} title={tooltip} onClick={clickHandler} ref={ref} style={style}>
          {!editMode && (stringValue && <div className={"mt-1"}>{stringValue}</div> || <>&nbsp;</>)}
          {!!editMode && <input type={"text"} onChange={changeHandler} onKeyUp={keyHandler} value={currentValue || ''} autoFocus={true} className={'p-0 m-0 border-0 bg-transparent'}/>}
      </div>
    )
}
export const Cell = ({column, row, value, applyChanges, highlightRows, ...props}) => {
    const rowIndex = row.treeInfo.rowIndex;
    const isLastNode = row.treeInfo.IsEmpty;
    const level = row.treeInfo.Level;
    const columnName = column.name;
    const readOnlyRow = !!row.ReadOnlyRow;
    const isEditable = column.fieldInfo.IsEditable;
    let highlight = false;

    if (column.name === 'SignFoundDelta_App') {
        return value === 1 && <div className={classes.attentionIcon} /> || '';
    }

    if (column.editorMethod === "Web_MultiLabel") {
        return <Web_MultiLabel highlightRows={highlightRows} column={column} row={row} value={value} />
    }

    let tooltip = column.tooltip && row[column.tooltip] || null;

    if (columnName === "OrgStructShortName" && level === 3 && !tooltip) {
        tooltip = row["OrgStructName"];
    }

    if (["OrgStructShortName", "OrgStructIdView"].includes(columnName) && highlightRows?.includes(rowIndex*1)) {
        highlight = true;
    }

    return <CellFormatter highlight={highlight} isEditable={isEditable && !readOnlyRow} value={value} tooltip={tooltip} level={level} fieldType={column.fieldInfo.FldType} fieldFormat={column.fieldInfo.Format} fieldName={columnName} rowIndex={rowIndex} applyChanges={applyChanges} />
}

const ExpandedCell = ({column, row, value, highlightRows, ...props}) => {
    const { IsEmpty, IsExpanded, IsFirst, IsLast, Level, rowIndex } = row.treeInfo

    const className = IsEmpty ? '' : `zmdi zmdi-${IsExpanded ? "minus" : "plus"}-square`;
    const clickHandler = (e) => {
        e.stopPropagation();
        props.toggleExpand(rowIndex, IsExpanded)
    }

    const mLeft = 22 * Level - (Level === 3 ? 6 : 0);

    return (
        <div className="d-flex flex-direction-row align-items-center text-nowrap ml-1 mr-1">
            <i className={className} onClick={clickHandler} style={{fontSize: "20px", margin: `0 5px 0 ${mLeft}px`, cursor: "pointer"}}/>
            <Cell {...props} highlightRows={highlightRows} column={column} row={row} value={value} />
        </div>
    )
}

const ARGridCellExtensions = (props) => {
    const CellFormatter = ({column, row, value}) => {
        if (column.isNodeKeeper && row.treeInfo ) {
            return (<ExpandedCell {...props} column={column} row={row} value={value} />);
        }

        return (<Cell {...props} column={column} row={row} value={value}/>);
    };
    return (
        <DataTypeProvider
            formatterComponent={CellFormatter}
            {...props}
        />
    );
};

export {ARGridCellExtensions};